import React from 'react';

import './FirmwareFile.scss';

export type FileType = 'html' | 'css' | 'js' | 'image' | 'font' | 'other';

export interface FirmwareFileProps {
  name: string;
  type: FileType;
  checked?: boolean;
  onClick: (file: any) => void;
}

class FirmwareFile extends React.Component<FirmwareFileProps> {

  static defaultProps = {
    checked: false
  }

  render() {
    const { name, checked } = this.props;
    return (
      <div className="col-xl-6 col-12 mb-2" onClick={this.handleClick}>
        <div className={'firmware-file-component' + (checked ? ' checked' : '')}>
          <div className="content">
            <div className="type-icon">{this.getIcon()}</div>
            <div className="file-name">{name}</div>
          </div>
        </div>
      </div>
    );
  }

  private getIcon = () => {
    switch (this.props.type) {
      case 'html':
        return <i className="fab fa-html5" style={{ color: '#E34B2D' }}></i>;
      case 'css':
        return <i className="fab fa-css3" style={{ color: '#276AEC' }}></i>;
      case 'js':
        return <i className="fab fa-js-square" style={{ color: '#edd124' }}></i>;
      case 'image':
        return <i className="far fa-image" style={{ color: '#84C738' }}></i>;
      case 'font':
        return <i className="far fa-font" style={{ color: '#5352ed' }}></i>;
      case 'other':
      default:
        return <i className="far fa-file-alt" style={{ color: '#2c3e50' }}></i>;
    }
  }

  private handleClick = (e: any) => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(this.props);
    }
  }

}

export default FirmwareFile;
